import React from 'react';

const VARIANTS = {
  chip: {
    item: 'mr-3 sm:mr-4 rounded-full shadow-[var(--border-ring)] bg-[var(--bg-elevated)] px-4 py-2 text-sm font-medium text-[var(--fg-secondary)] transition-colors duration-200 hover:bg-[var(--bg-hover)] hover:text-[var(--fg-primary)]',
    icon: 'h-4 w-4 text-[var(--fg-secondary)]',
    gap: 'gap-2'
  },
  display: {
    item: 'mr-8 sm:mr-14 text-2xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[var(--fg-primary)] transition-colors duration-200 hover:opacity-80',
    icon: 'h-6 w-6 sm:h-8 sm:w-8 lg:h-10 lg:w-10 text-[var(--fg-primary)]',
    gap: 'gap-3 sm:gap-4'
  },
  muted: {
    item: 'mr-10 sm:mr-16 text-sm sm:text-lg font-medium text-[var(--fg-secondary)] transition-colors duration-200 hover:text-[var(--fg-primary)]',
    icon: 'h-4 w-4 sm:h-5 sm:w-5 text-[var(--fg-muted)]',
    gap: 'gap-2 sm:gap-2.5'
  }
};

const MIN_PER_GROUP = { chip: 20, display: 12, muted: 10 };

const TechnologyMarquee = ({
  items = [],
  speed = 30,
  direction = 'left',
  variant = 'chip',
  className = ''
}) => {
  if (!items.length) return null;

  const style = VARIANTS[variant] || VARIANTS.chip;

  const normalized = items.map((item) =>
    typeof item === 'string' ? { name: item } : item
  );

  const group = Array.from(
    { length: Math.ceil((MIN_PER_GROUP[variant] ?? MIN_PER_GROUP.chip) / normalized.length) },
    () => normalized
  ).flat();

  const Group = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {group.map((item, index) => {
        const { IconComponent } = item;
        return (
          <span
            key={`${item.name}-${index}`}
            className={`group/item inline-flex shrink-0 items-center whitespace-nowrap ${style.gap} ${style.item}`}
          >
            {IconComponent && (
              <IconComponent
                className={`shrink-0 ${style.icon}`}
              />
            )}
            {item.name}
          </span>
        );
      })}
    </div>
  );

  return (
    <div className={`marquee relative flex items-center overflow-hidden ${className}`}>
      <div
        className="marquee__track flex w-max shrink-0 items-center"
        style={{
          animationName: direction === 'left' ? 'marquee-left' : 'marquee-right',
          animationDuration: `${speed}s`
        }}
      >
        <Group />
        <Group hidden />
      </div>
    </div>
  );
};

export default TechnologyMarquee;
